import { render, staticRenderFns } from "./shuffle-btn.vue?vue&type=template&id=f1b8e3c2&scoped=true&"
import script from "./shuffle-btn.vue?vue&type=script&lang=ts&"
export * from "./shuffle-btn.vue?vue&type=script&lang=ts&"
import style0 from "./shuffle-btn.vue?vue&type=style&index=0&id=f1b8e3c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b8e3c2",
  null
  
)

export default component.exports